import React from 'react';
import { translate } from '@utils/i18n';
import { Tag } from '@ui/atoms/Tag';
import { NAMESPACE } from '../constants';
export function LocationCell({ item }) {
    return (React.createElement("span", { className: "sprinkler-projection__location-cell" },
        React.createElement("span", null, item.location),
        item.isHarshEnvironment && (React.createElement(Tag, { label: translate('env_tags.harsh_environment', { namespace: NAMESPACE }), variant: "red", readOnly: true }))));
}
